import { isArrayValid } from "../helpers/utility";
import BaseService from "./BaseService";
import { UpdateNameModel } from "../core/contracts/UpdateNameModel";

export default class OrganizationService extends BaseService {
  async fetch(): Promise<string[]> {
    try {
      const APIResponse = await new BaseService(true).get<string[]>(
        "/core/InstallationGroup/GetOrganizationList"
      );

      if (isArrayValid(APIResponse)) {
        return APIResponse.filter((x) => x);
      }

      return new Promise((_, rej) => rej(`Invalid response → ${APIResponse}`));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("OrganizationService -> fetch -> error", error);
      return new Promise((_, rej) => rej(error));
    }
  }

  async update(organizationNameModel: UpdateNameModel): Promise<boolean> {
    try {
      return await new BaseService(true).post<boolean, UpdateNameModel>(
        "/core/InstallationGroup/UpdateOrganizationName",
        organizationNameModel
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("OrganizationService -> update -> error", error);
      return Promise.reject(error);
    }
  }

  async count(organizationName: string): Promise<number> {
    try {
      const APIResponse = await new BaseService(true).get<number>(
        `/core/InstallationGroup/CountOrganizationName/${organizationName}`
      );
      return APIResponse;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("OrganizationService -> count -> error", error);
      return Promise.reject(error);
    }
  }
}
